import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// data-controller="trix-attach"
// data-trix-attach-target="editor"
export default class extends Controller {
  static targets = ["editor", "input"]

  chooseFile() {
    if (this.hasInputTarget) {
      this.inputTarget.click()
    }
  }

  async attachFiles(event) {
    const files = Array.from(event.target.files || [])
    if (!this.hasEditorTarget || files.length === 0) return
    const editor = this.editorTarget
    const trix = editor.editor
    for (const f of files) {
      trix.insertFile(f)
    }
    // reset input so same file can be reselected
    event.target.value = ""
  }
}

